
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import { getLevelOptions } from "../common";
import { caijiMixin } from "./take-photos-video/caijiMixin";
import SubTitle from "./title-sub.vue";
import Title from "./title.vue";
@Component({
  components: {
    Title,
    SubTitle,
  },
})
export default class Name extends mixins(caijiMixin) {
  @Prop()
  private content: any; // 整个content数据
  @Watch("content", { immediate: true })
  private contentChange() {
    if (this.content) {
      this.cContent = JSON.parse(JSON.stringify(this.content));
      if (this.cContent.report && !this.cContent.report["舌象信息"]) {
        this.cContent.report["舌象信息"] = {
          舌神: [[], []],
          舌色: [[], []],
          舌形: [[], []],
          舌态: [[], []],
          苔质: [[], []],
          苔色: [[], []],
        };
        // 转格式,填充数据
        const oldData: any = this.cContent.report["舌象信息输出"];
        // 舌色
        if (oldData[0]) {
          const text: any = oldData[0];
          this.cContent.report["舌象信息"]["舌色"][0].push(text);
        }
        // 边尖红
        if (oldData[1] && oldData[1] == "有") {
          this.cContent.report["舌象信息"]["舌色"][1].push("边尖红");
        }
        // 瘀斑瘀点
        if (oldData[2] && oldData[2] == "有") {
          this.cContent.report["舌象信息"]["舌形"][0].push("有瘀斑瘀点");
        }
        // 苔色
        if (oldData[3]) {
          const text: any = oldData[3];
          this.cContent.report["舌象信息"]["苔色"][0].push(text);
        }
        // 厚薄
        if (oldData[4]) {
          const text: any = oldData[4];
          this.cContent.report["舌象信息"]["苔质"][0].push(text);
        }
        // 腻
        if (oldData[5] && oldData[5] == "有") {
          this.cContent.report["舌象信息"]["苔质"][0].push("腻");
        }
        // 腐
        if (oldData[6] && oldData[6] == "有") {
          this.cContent.report["舌象信息"]["苔质"][0].push("腐");
        }
        // 苔剥
        if (oldData[7] && oldData[7] == "有") {
          this.cContent.report["舌象信息"]["苔质"][0].push("有苔剥");
        }
        // 胖瘦
        if (oldData[8]) {
          const text: any = oldData[8];
          this.cContent.report["舌象信息"]["舌形"][0].push(text);
        }
        // 齿痕
        if (oldData[9] && oldData[9] == "有") {
          this.cContent.report["舌象信息"]["舌形"][0].push("有齿痕");
        }
        // 点刺
        if (oldData[10] && oldData[10] == "有") {
          this.cContent.report["舌象信息"]["舌形"][0].push("有点刺");
        }
        // 裂纹
        if (oldData[11] && oldData[11] == "有") {
          this.cContent.report["舌象信息"]["舌形"][0].push("有裂纹");
        }
        this.cContent.report["舌象信息"]["舌神"][0].push("荣");
        this.cContent.report["舌象信息"]["舌态"][0].push("正常");

        this.$emit("updateContent", JSON.parse(JSON.stringify(this.cContent)));
        setTimeout(() => {
          // 保存
          this.$emit("save");
        }, 200);
        this.$forceUpdate();
      }
    }
  }
  @Prop()
  private index: any; // 当前题目的索引
  @Prop()
  private data: any; // 题目的数据
  @Watch("data", { immediate: true })
  private dataChange() {
    if (this.data) {
      this.c = JSON.parse(JSON.stringify(this.data));
    }
  }
  @Prop()
  private source: any; //dialog,审核修改弹框;renkouxue,人口学和受试者信息;
  getLevelOptions(type: any, key: any, level: any) {
    return getLevelOptions(type, key, level);
  }
  /**
   * @param val <string array>
   */
  private getShowContent(val: any) {
    let result: any = "";
    if (val && val.length > 0) {
      result = val.join("、");
    }
    return result;
  }
}
